import { SvgIcon, SvgIconProps } from "@mui/material";

export const OctagonShapeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        />
    </SvgIcon>
);